module.exports = __webpack_public_path__ + "img/shanghai.b5c9aad0.png";